// @flow
import { StaffProfilesActionTypes } from './constants';

type StaffProfilesAction = { type: string, payload: {} | string };

// common success
export const staffProfilesApiResponseSuccess = (actionType: string, data: any): StaffProfilesAction => ({
    type: StaffProfilesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const staffProfilesApiResponseError = (actionType: string, error: string): StaffProfilesAction => ({
    type: StaffProfilesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listStaffProfiles = (): StaffProfilesAction => ({
    type: StaffProfilesActionTypes.LIST_STAFF_PROFILES,
    payload: {},
});

export const resetStaffProfiles = (): StaffProfilesAction => ({
    type: StaffProfilesActionTypes.RESET,
    payload: {},
});

